module.exports = __webpack_public_path__ + "img/Pic_Logo-white.018a9585.png";